<template>
  <div class="c-table" ref="recordkpitable">
    <el-table class="common-el-table-styles" :data="data" :height="height" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'reportMonth'">{{ scope.row[col.key] }}</span>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">修改</el-button>
            <Poptip confirm transfer title="您确认删除该自然量充值比吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small">&ensp;删除</el-button>
            </Poptip>
          </div>
          <span v-else-if="col.key === 'upTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'platform'">{{ scope.row[col.key] | platform }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'iosRechargeTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  filters: {
    platform(cell) {
      if (cell === 1) return '安卓'
      else if (cell === 2) return 'iOS'
      else if (cell === 3) return '小程序'
      else return '未知'
    }
  }
}
</script>
